<div style="margin: 10px 10px 10px 10px;">

	<switch-to-jack-lookup-editor [ifTableHeightVh]="100" [ifTableHeightPx]="-510" [ifTableMinHeight]="150">
	</switch-to-jack-lookup-editor>

</div>
